<template>
  <div class="base-status-tag" :class="`-${theme}`">{{ status }}</div>
</template>

<script lang="ts" setup>
  import { ACCOUNT_RESUME_PUBLISHING_STATUS_THEME } from '~/shared/const/pages/account-resumes'

  const props = defineProps({
    status: {
      type: String,
      default: '',
    },
  })


  const theme = computed(() => ACCOUNT_RESUME_PUBLISHING_STATUS_THEME[props.status] || 'hidden')
</script>

<style lang="scss" scoped>
  .base-status-tag {
    display: inline-flex;
    align-items: center;
    padding: 6px 16px;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    white-space: nowrap;

    &.-approved {
      color: $color-kiwi-70;
      background-color: $color-kiwi-10;
    }

    &.-rejected {
      color: $color-chilli-70;
      background-color: $color-chilli-10;
    }

    &.-review {
      color: $color-banana-90;
      background-color: $color-banana-10;
    }

    &.-hidden,
    &.-draft {
      color: $color-potato-90;
      background-color: $color-potato-20;
    }
  }
</style>
